export default __webpack_public_path__ + "static/bg-page-about-23bf0d955c063fa91f58a23f359a1815.jpg";